export default "__VITE_ASSET__0c3beb90__"